import React, { createContext, useContext, useEffect, useState } from "react";
import { themeSlice } from "./redux/slices/themeSlice";
import { useDispatch } from "react-redux";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const dispatch = useDispatch()
  const [theme, setTheme] = useState(() => {
  // lazy initializer, first check localStorage
  return localStorage.getItem("theme") || "dark";
});

useEffect(() => {
  document.documentElement.className = theme === "light" ? "light" : "";
  localStorage.setItem("theme", theme);
  dispatch(themeSlice(theme));
}, [theme]);
// 🔥 default dark

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme); // agar user ne pehle light select kiya tha
    } else {
      setTheme("dark"); // warna default dark hi rahega
    }
  }, []);

  useEffect(() => {
    document.documentElement.className = theme === "light" ? "light" : "";
    localStorage.setItem("theme", theme);
    dispatch(themeSlice(theme))
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
